
/*********************************************************************
 *
 * WARNING: This shader class is automatically generated, any manual
 * edits will be lost.
 *
 ********************************************************************/
import { ShaderBase, ShaderUniformsContainer, ShaderAttributesContainer } from '../shader';
import { Texture, CubeMapTexture } from '../../texture';
import { Context } from '../../context/Context';
import { mat3, mat4, vec2, vec3, vec4 } from "gl-matrix";
import { ShaderSourceParser } from '../shader-source-parser';

export type TestGeometryShaderUniforms = {
	uModelViewMatrix: WebGLUniformLocation,
	uProjectionMatrix: WebGLUniformLocation
};

export type TestGeometryShaderAttributes = {
	aVertexPosition: number,
	aVertexColor: number,
	vVertexColor: number
};

export type TestGeometryShaderSettings = string[];

export class TestGeometryShader extends ShaderBase<TestGeometryShaderUniforms, TestGeometryShaderAttributes> {

    private static fragmentShaderSource = `
out vec4 fragColor;
in vec4 vVertexColor;

void main(void) {
	fragColor = vVertexColor;
}
`;

    private static vertexShaderSource = `
layout(location = 0) in vec3 aVertexPosition;
layout(location = 3) in vec4 aVertexColor;

uniform mat4 uModelViewMatrix;
uniform mat4 uProjectionMatrix;
out vec3 vVertexPosition;
out vec4 vVertexColor;

void main(void) {
	gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(aVertexPosition.xyz, 1.0);
	vVertexPosition = aVertexPosition;
	vVertexColor = aVertexColor;
}
`;

    public override get version(): string {
        return '300 es';
    }

    public override get parser(): any {
        return new ShaderSourceParser();
    }

    protected override get warnAttributeMismatch(): boolean {
        return false;
    }

    public uniformsContainer: TestGeometryShaderUniformsContainer;
    public attributesContainer: TestGeometryShaderShaderAttributesContainer;

    constructor(ctx: Context, settings: TestGeometryShaderSettings) {
        super(ctx, TestGeometryShader.fragmentShaderSource, TestGeometryShader.vertexShaderSource, settings);
        this.uniformsContainer = new TestGeometryShaderUniformsContainer(ctx, this);
        this.attributesContainer = new TestGeometryShaderShaderAttributesContainer(ctx, this);
    }
}

class TestGeometryShaderUniformsContainer extends ShaderUniformsContainer {
    constructor(ctx: Context, private shader: TestGeometryShader) {
        super(ctx);
    }

    public setModelViewMatrix(value: mat4 | number[]) : TestGeometryShaderUniformsContainer {
        this.setValue('uModelViewMatrix', this.shader.uniforms.uModelViewMatrix, value, 'mat4');
        return this;
    }

    public setProjectionMatrix(value: mat4 | number[]) : TestGeometryShaderUniformsContainer {
        this.setValue('uProjectionMatrix', this.shader.uniforms.uProjectionMatrix, value, 'mat4');
        return this;
    }

    protected getTextureUniforms() {
        return [

        ];
    }
}

class TestGeometryShaderShaderAttributesContainer extends ShaderAttributesContainer {
    constructor(ctx: Context, private shader: TestGeometryShader) {
        super(ctx);
    }

    public setVertexPosition(settings: { length: number, offset: number, itemSize: number }) : TestGeometryShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.aVertexPosition, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }

    public setVertexColor(settings: { length: number, offset: number, itemSize: number }) : TestGeometryShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.aVertexColor, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }

    public setvVertexColor(settings: { length: number, offset: number, itemSize: number }) : TestGeometryShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.vVertexColor, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }
}